import { InjectionToken } from '@angular/core';

/**
 * Interface for error handler that can be provided by consuming applications
 * Allows integration with various error tracking services (e.g. Sentry)
 */
export interface TranscribeErrorHandler {
  /**
   * Log an error with optional context
   * @param message Error message
   * @param error Optional error object
   */
  error(message: string, error?: unknown): void;

  /**
   * Log a warning
   * @param message Warning message
   */
  warn?(message: string): void;

  /**
   * Log an info message
   * @param message Info message
   */
  info?(message: string): void;
}

/**
 * Injection token for the error handler
 * Consuming apps can provide their own implementation (e.g., SentryTranscribeErrorHandler)
 * If not provided, defaults to console logging
 */
export const TRANSCRIBE_ERROR_HANDLER = new InjectionToken<TranscribeErrorHandler>(
  'TranscribeErrorHandler'
);

/**
 * Default console-based error handler
 * Used when no custom error handler is provided
 */
export class ConsoleErrorHandler implements TranscribeErrorHandler {
  error(message: string, error?: unknown): void {
    console.error(`[Transcribe] ${message}`, error);
  }

  warn(message: string): void {
    console.warn(`[Transcribe] ${message}`);
  }

  info(message: string): void {
    console.log(`[Transcribe] ${message}`);
  }
}
